import React from 'react';
import './poolMemeberrow.css';

/**
 * INCSUBpoolMemeberrow Component
 * @author vishal lohbande
 * Renders a single row of pool member details including:
 * - Profile image
 * - Member name
 * - Pool joining date
 * - Plan price
 * - Refund status
 * - Action button (Suspend or Suspended)
 * 
 * Props:
 * @param {Object} props - Component props
 * @param {Object} props.member - Member object containing profile details and status
 * @param {Function} props.fun - Callback function to be called on suspension action
 * @param {Object} props.pool - Pool object, used to pass poolId for action
 * 
 * @returns {JSX.Element} The rendered component
 */
function INCSUBpoolMemeberrow({ member, fun, pool }) {

    /**
     * Formats a date string into "dd MMM yyyy" format.
     * 
     * @param {string} dateString - A valid date string
     * @returns {string} Formatted date string
     */
    const formateDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: 'short',
            year: "numeric"
        }).format(date);
    };

    return (
        <div className='INCSUBPoolMemberDetail_memberrow'>
            
            {/* Profile and name section */}
            <div className='INCSUBPoolMemberDetail_headrow_name'>
                <div className='INCSUBPoolMemberDetail_memberrow_img_name'>
                    <img
                        className='INCSUBPoolMemberDetail_memberrow_img'
                        src={member.memberImage?member.memberImage:'/assets/icons/common/defaultImage.png'}
                        alt="default img"
                    />
                </div>
                <div className='INCSUBPoolMemberDetail_memberrow_name'>
                    {member.memberName}
                </div>
                <div>{/* Reserved for future content or alignment */}</div>
            </div>

            {/* Joining date */}
            <div className='INCSUBPoolMemberDetail_headrow_joinindate'>
                {formateDate(member.poolJoiningDate)}
            </div>

            {/* Plan price */}
            <div className='INCSUBPoolMemberDetail_headrow_planprice'>
                ₹ {member.planPriceForTheMember}
            </div>

            {/* Refund status */}
            <div className='INCSUBPoolMemberDetail_headrow_refund'>
                {member.refundStatus}
            </div>

            {/* Action button */}
            <div className='INCSUBPoolMemberDetail_headrow_Action'>
                {member && !member.suspended ? (
                    <button
                        className='suspend'
                        onClick={() => fun(pool.poolId, member.memberId, 'User')}
                    >
                        Suspend
                    </button>
                ) : (
                    <button
                        className='revoke'
                        style={{ cursor: "default" }}
                    >
                        Suspended
                    </button>
                )}
            </div>
        </div>
    );
}

export default INCSUBpoolMemeberrow;
